import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { OptionsMappingPipe } from 'src/app/shared/pipes/options-mapping.pipe';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'laas-do-search',
  templateUrl: './do-search.component.html',
  styleUrls: ['./do-search.component.scss']
})
export class DoSearchComponent extends SessionBaseComponent implements OnInit {
  readonly preferenceKey: string;
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewQueryDoStatus;
  facilityOptions: any;
  selectedFacility: string[];
  orderType: number;
  isDepOrderInclude: boolean;
  orderStatus: number;
  columns: any[];
  selectedCols: any[];
  selectedDORows: any[];
  DORows: any[];
  isSearchFormOpen: boolean;
  isLoading: boolean;
  startDate: Date;
  endDate: Date;
  consigneeCompany: string;
  doNo: string;
  selectedDoc: any;
  DOStatusOptions: any[];
  showDoFile: boolean;
  doNoFile: string;
  noShippingReasonOptions: any[];
  waitingReasonOptions: any[];

  //translate label
  RemarkUrgentDO: any;

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private dropdownOptionService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private optionsMappingPipe: OptionsMappingPipe,
    private translate: TranslateService) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.DOSearchForSales;
    this.isSearchFormOpen = true;
    this.orderType = 1;
    this.isDepOrderInclude = false;
    this.orderStatus = 1;
    this.columns = [
      { field: 'facility', header: 'ShippingStatus.MainTable.Facility' },
      { field: 'doNo', header: 'ShippingStatus.MainTable.DONum' },
      { field: 'consigneeCompany', header: 'ShippingStatus.MainTable.Customer' },
      { field: 'cartonCnt', header: 'ShippingStatus.MainTable.NumCartons' },
      { field: 'doStatus', header: 'ShippingStatus.MainTable.Status' },
      { field: 'estimatedLeaveWarehouseDt', header: 'ShippingStatus.MainTable.EstimateLeave' },
      { field: 'fixedEstimatedLeaveWarehouseDt', header: 'ShippingStatus.MainTable.ReEsitmate' },
      { field: 'leaveWarehouseDt', header: 'ShippingStatus.MainTable.ActualLeave' },
      { field: 'reasons', header: 'ShippingStatus.MainTable.Remarks' },
      { field: 'download', header: 'ShippingStatus.MainTable.FileDownload' }
    ];
    this.selectedCols = this.columns;
    this.DORows = [];
    this.selectedFacility = [];
    this.selectedDORows = [];
    this.isLoading = false;
    this.startDate = new Date();
    this.endDate = new Date();
    this.consigneeCompany = '';
    this.doNo = '';
    this.DOStatusOptions = [];
    this.showDoFile = false;
    this.doNoFile = '';
    this.noShippingReasonOptions = [];
    this.waitingReasonOptions = [];

    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionService.getFacilityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getDOStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.DOStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'NoShippingReason', this.laasSetting.facility)
      .subscribe({
        next: (models: any[]) => {
          this.noShippingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'WaitingReason', this.laasSetting.facility)
      .subscribe({
        next: (models: any[]) => {
          this.waitingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  resetBtnClick(event: any): void {
    this.orderType = 1;
    this.orderStatus = 1;
    this.isDepOrderInclude = false;
    //this.selectedFacility = [];
    this.consigneeCompany = '';
    this.doNo = '';
    this.startDate = new Date();
    this.endDate = new Date();
  }

  searchBtnClick(event: any): void {
    this.isLoading = true;
    this.selectedDORows = [];
    this.DORows = [];

    var dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    const filterObj = {
      orderType: this.orderType,
      status: this.orderStatus,
      facility: this.selectedFacility,
      consigneeCompany: this.consigneeCompany,
      doNo: this.doNo,
      outboundStartDt: this.startDate,
      outboundEndDt: this.endDate,
      salescode: '',
      dept: '',
      dataScopes: dataScopes
    };

    this.DOService.getDoByFilter(filterObj).subscribe({
      next: result => {
        this.isSearchFormOpen = !this.isSearchFormOpen;
        this.DORows = result;

        this.DORows.forEach(item => {
          item.reasons = this.getFormatedReasons(item);
          item.downloadOptions = [];
          item.selectedDownload = '';
          item.badges = 0;
          if (item.download != null) {
            const tmpDownloadArr = item.download.split(',');
            item.badges = tmpDownloadArr.length;
            for (const download of tmpDownloadArr) {
              const docArr = download.split('｜');
              item.downloadOptions.push({
                text: docArr[0],
                value: docArr[0],
                version: docArr[1],
                sn: docArr[2],
                fileType: docArr[3]
              });
            }

            item.downloadOptions.unshift({
              text: '請選擇',
              value: ''
            });
          }
        });

      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  downloadChange(event: any, downnloadObj: any): void {
    if (downnloadObj.selectedDownload !== '') {
      this.selectedDoc = {};
      for (const download of downnloadObj.downloadOptions) {
        if (download.value === downnloadObj.selectedDownload) {
          this.selectedDoc = download;
        }
      }

      this.DOService.downloadFile(this.selectedDoc).subscribe(x => {
        const blob = new Blob([x], { type: 'application/octet-stream' });
        const downloadURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = `${this.selectedDoc.value}.${this.selectedDoc.fileType}`;
        link.click();
      });
    }
  }

  dateChange(event: any, type: number): void {
    const now = new Date();
    let startDate = new Date();

    switch (type) {
      case 1:
        this.startDate = now;
        break;
      case 2:
        startDate = now.addDays(-3);
        this.startDate = startDate;
        break;
      case 3:
        startDate = now.addDays(-7);
        this.startDate = startDate;
        break;
      case 4:
        startDate = now.addDays(-14);
        this.startDate = startDate;
        break;
      case 5:
        startDate = now.addMonth(-1);
        this.startDate = startDate;
        break;
      default:
        break;
    }

    this.endDate = now;
  }

  fileBtnClick(event: any, rowData: any): void {
    this.doNoFile = rowData.doNo;
    this.showDoFile = true;
  }

  closeFile(display: boolean): void {
    this.showDoFile = display;
  }

  DOLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo('/TransportOperation/DODetail', rowData, true);
  }

  priorityBtnClick(event: any): void {
    this.confirmationService.confirm({
      //是否註記為急單?
      message: this.RemarkUrgentDO,
      acceptLabel: '是',
      rejectLabel: '否',
      accept: () => {
        const doNos = this.selectedDORows.map(x => x.doNo);
        this.batchUpdateDOPriority(doNos);
      }
    });
  }

  getFormatedReasons(rowData: any): string[] {
    let waitingReasons = (isNullOrEmpty(rowData.waitingReason) ? [] : rowData.waitingReason.split(','))
      .map((x: string) => {
        return this.optionsMappingPipe.transform(x, this.waitingReasonOptions);
      });

    const noShippingReason = this.optionsMappingPipe.transform(rowData.noShippingReason, this.noShippingReasonOptions);
    if (!isNullOrEmpty(noShippingReason)) {
      waitingReasons = waitingReasons.concat(noShippingReason);
    }

    return waitingReasons;
  }

  private batchUpdateDOPriority(doNos: string[]): void {
    this.DOService.updatePriorityByDONos(doNos, '1')
      .subscribe({
        next: () => {
          this.searchBtnClick(null);
        },
        error: err => {
          this.toastService.error(err.error);
        }
      });
  }

  translationLabel(){
    this.RemarkUrgentDO = this.translateService.instant('DOSearchForShip.Confirm.RemarkUrgentDO');
  }
}
